import { z } from "zod";
import { week } from "@/shared/week";

/**
 * The days a week is worked and how long a working day is. No start or end time: hours are
 * counted, never measured against a clock (`docs/spec/attendance.md`).
 */
const schedule = z.object({
  week,
  minutesPerDay: z.number().int(),
});

/** The years the calendar holds; the holidays page steps no further. */
export const CALENDAR_YEARS = { first: 2000, last: 2100 } as const;
export const calendarYear = z.coerce
  .number()
  .int()
  .min(CALENDAR_YEARS.first)
  .max(CALENDAR_YEARS.last);

const holiday = z.object({
  id: z.string(),
  day: z.iso.date(),
  name: z.string(),
});

export type Schedule = z.infer<typeof schedule>;
export type Holiday = z.infer<typeof holiday>;
